import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export type UserTypesName = keyof typeof userTypesEnum
export const userTypesEnum = {
  HOLDER: { label: "Titulaire Pharma" },
  TEAM: { label: "Equipe Pharma" },
  ADVISOR: { label: "CDO" },
  EXTERN: {
    label: "Intervenant Ext",
    refs: { multi: false, refs: "externSpecification" },
  },
  ADMINISTRATOR: { label: "Administrateur" },
} as const satisfies ReferentialEnum<{
  refs?: { multi: boolean; refs: string }
}>

export const userTypesReferential =
  referentialEnumToReferentialCodeList<
    ReferentialEnum<{
      refs?: { multi: boolean; refs: string }
    }>
  >(userTypesEnum)
